import { FIELD_TYPE } from "@commonComponents/massUpdate/constants"
// level- invoice || merchandise || mdocument
export const FIELD_NAMES_MERCH_IMPORT = [
    {
        key: 'procedure',
        text: 'PROCEDURE',
        text_nl: 'PROCEDURE',
        value: '1',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'merchandise'
    },
    {
        key: 'originCountry',
        text: 'ORIGIN',
        text_nl: 'OORSPRONG',
        value: '2',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'merchandise'
    },
    {
        key: 'cusCode',
        text: 'CUS CODE',
        text_nl: 'CUS-CODE',
        value: '3',
        fieldType: FIELD_TYPE.FREE_TEXT,
        level:'merchandise'
    },
    {
        key: 'preference',
        text: 'PREFERENTIAL ORIGIN',
        text_nl: 'PREFERENTIËLE OORSPRONG',
        value: '4',
        fieldType: FIELD_TYPE.FREE_TEXT,
        level:'merchandise'
    },
    {
        key: 'type',
        text: 'TYPE (PACKAGING)',
        text_nl: 'TYPE (PACKAGING)',
        value: '5',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'mdocument',
        mdocumentName:'packagesList'
    },
    {
        key: 'quantity',
        text: 'PACKAGE QTY (PACKAGING)',
        text_nl: 'PACKAGE QTY (PACKAGING)',
        value: '6',
        fieldType: FIELD_TYPE.FREE_TEXT,
        level:'mdocument',
        mdocumentName:'packagesList'
    },
    {
        key: 'shippingMarks',
        text: 'SHIPPING MARKS (PACKAGING)',
        text_nl: 'SHIPPING MARKS (PACKAGING)',
        value: '7',
        fieldType: FIELD_TYPE.FREE_TEXT,
        level:'mdocument',
        mdocumentName:'packagesList'
    }
]

export const FIELD_NAMES_MERCH_EXPORT = [
    {
        key: 'procedure',
        text: 'PROCEDURE',
        text_nl: 'PROCEDURE',
        value: '1',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'merchandise'
    },
    {
        key: 'originCountry',
        text: 'ORIGIN',
        text_nl: 'OORSPRONG',
        value: '2',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'merchandise'
    },
    {
        key: 'preference',
        text: 'PREFERENTIAL ORIGIN',
        text_nl: 'PREFERENTIËLE OORSPRONG',
        value: '3',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'merchandise'
    },
    {
        key: 'natureOfTransaction',
        text: 'NATURE OF TRANSACTION',
        text_nl: 'NATURE OF TRANSACTION',
        value: '4',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'merchandise'
    },
    {
        key: 'type',
        text: 'TYPE (PACKAGING)',
        text_nl: 'TYPE (PACKAGING)',
        value: '5',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'mdocument',
        mdocumentName:'packagesList'
    },
    {
        key: 'quantity',
        text: 'PACKAGE QTY (PACKAGING)',
        text_nl: 'PACKAGE QTY (PACKAGING)',
        value: '6',
        fieldType: FIELD_TYPE.FREE_TEXT,
        level:'mdocument',
        mdocumentName:'packagesList'
    },
    {
        key: 'shippingMarks',
        text: 'SHIPPING MARKS (PACKAGING)',
        text_nl: 'SHIPPING MARKS (PACKAGING)',
        value: '7',
        fieldType: FIELD_TYPE.FREE_TEXT,
        level:'mdocument',
        mdocumentName:'packagesList'
    }
]